<template>
  <v-container fill-height fluid>
    <v-row align="center">
      <div style="text-align: center; width: 90%">
        <span
          style="color: #f00"
          v-if="inventoryResponse"
          v-text="inventoryResponse.message"
        ></span
        ><br />
        <span v-if="isInventoryLoading">Loading your tickets ...</span>
      </div>
      <v-progress-linear
        v-if="isInventoryLoading"
        indeterminate
        color="primary"
        class="mx-6"
      ></v-progress-linear>
      <div style="text-align: center; width: 90%">
        <v-alert v-if="showLoadingError">
          A network error has stalled your transaction. Please
          <router-link :to="customer.CustomerListingUrl"
            >click here</router-link
          >
          to return and resubmit.
        </v-alert>
      </div>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      showLoadingError: false
    };
  },
  computed: {
    ...mapGetters(["isPackage", "isInventoryLoading"]),
    ...mapState({
      customer: state => state.customer,
      inventoryResponse: state => state.inventoryResponse
    })
  },
  created() {
    this.showLoadingError = false;
    if (this.isPackage) {
      this.$store.dispatch("REQUEST_PACKAGE_INVENTORY");
    }
    this.$watch("isPackage", function(newValue) {
      if (newValue) {
        this.$store.dispatch("REQUEST_PACKAGE_INVENTORY");
      }
    });

    this.$watch("isInventoryLoading", function(newValue) {
      if (newValue === false) {
        if (this.inventoryResponse?.error) {
          this.showLoadingError = true;
        } else {
          this.$router.push("/payment");
        }
      }
    });
  }
};
</script>
